export const TOOLTIP_ENTER_DELAY = 100;

export const TOOLTIP_ENTER_TOUCH_DELAY = 0;

/** Matches the grow-out duration in tooltip.scss. */
export const TOOLTIP_EXIT_DURATION = 200;

export const TOOLTIP_LEAVE_DELAY = 200;

/** How long the tooltip stays up after a finger lifts. */
export const TOOLTIP_LEAVE_TOUCH_DELAY = 1500;

/** Reopening this soon after a close skips the enter delay: 800ms after the leave delay. */
export const TOOLTIP_REENTRY_WINDOW = 1000;

/** Mouse events stay ignored this long after a touch-opened tooltip closes. */
export const TOOLTIP_TOUCH_RESET_DELAY = 150;
